import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { X, Search } from 'lucide-react';

interface SearchBoxProps {
  label: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  onSearch?: () => void;
  showClearButton?: boolean;
  showSearchButton?: boolean;
  keepResultsOnClear?: boolean;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  label,
  value,
  placeholder,
  onChange,
  onClear,
  onSearch,
  showClearButton = false,
  showSearchButton = false,
  keepResultsOnClear = false,
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
      if (!keepResultsOnClear && onSearch) {
        setTimeout(onSearch, 0);
      }
    }
  };

  const hasButtons = (showClearButton && value) || showSearchButton;

  return (
    <>
      <Form.Label className="mb-1" style={{ fontSize: '0.75rem', fontWeight: '500', color: '#ccc' }}>
        {label}
      </Form.Label>
      {hasButtons ? (
        <InputGroup size="sm">
          <Form.Control
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && onSearch) {
                onSearch();
              }
            }}
            style={{ fontSize: '0.8rem' }}
          />
          {showClearButton && value && (
            <Button variant="outline-light" onClick={handleClear} title="Clear search">
              <X size={14} />
            </Button>
          )}
          {showSearchButton && onSearch && (
            <Button variant="outline-light" onClick={onSearch} title="Search">
              <Search size={14} />
            </Button>
          )}
        </InputGroup>
      ) : (
        <Form.Control
          size="sm"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{ fontSize: '0.8rem' }}
        />
      )}
    </>
  );
};

